import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import { routeChangeEvent } from '@ibe/services';
import { Header, configurationService, useAuthenticate } from '@ibe/tupvid-components';
import { useTranslation } from '@ibe/components';
import ProtectedRoute from './Components/ProtectedRoute';
import { getPageByUrl, pages } from './pages';
import PageUrl from './Models/PageUrl';
import SessionTimeoutWrapper from './Components/SessionTimeoutWrapper';
import Keys from './Translations/generated/App.en.json.keys';
import fallback from './Translations/generated/App.en.json';

// own component because useEffect will cause a re-render
const RouteBroadcast = (): JSX.Element => {
  const location = useLocation();
  useEffect(() => routeChangeEvent.broadcast(location), [location]);
  return <></>;
};

const App = observer(() => {
  const { authenticateService } = useAuthenticate();
  const { t } = useTranslation('App', fallback);
  const headerRef = useRef<{ closeMenu: () => void }>(null);
  return (
    <>
      <Header
        ref={headerRef}
        imgLeft="937-logo-its.svg"
        imgRight="1286-travel_up_video.png"
        Menu={
          authenticateService.isLoggedIn ? (
            <div className="masterdata__menu">
              <div>
                <Link onClick={(): void => headerRef?.current?.closeMenu()} to={PageUrl.HOME}>
                  {t(Keys.menuSnippets)}
                </Link>
              </div>
              <div>
                <Link onClick={(): void => headerRef?.current?.closeMenu()} to={PageUrl.AUDIODATA}>
                  {t(Keys.menuAudio)}
                </Link>
              </div>
              {configurationService.configuration.charity && (
                <div>
                  <Link
                    onClick={(): void => headerRef?.current?.closeMenu()}
                    to={PageUrl.CHARITYDATA}
                  >
                    {t(Keys.menuCharity)}
                  </Link>
                </div>
              )}
              <div>
                <Link onClick={(): void => headerRef?.current?.closeMenu()} to={PageUrl.LOGOUT}>
                  {t(Keys.menuLogout)}
                </Link>
              </div>
            </div>
          ) : null
        }
      />
      <Switch>
        {Object.keys(pages).map(url => {
          const page = getPageByUrl(url);
          return page.requiredRoles && page.requiredRoles.length > 0 ? (
            <ProtectedRoute
              requiredRoles={page.requiredRoles}
              redirectTo={page.redirectTo ? page.redirectTo : PageUrl.LOGIN}
              exact={url === '/'}
              path={url}
              key={url}
            >
              <>{page.component}</>
            </ProtectedRoute>
          ) : (
            <Route exact path={url} key={url}>
              <>{page.component}</>
            </Route>
          );
        })}
      </Switch>
      <RouteBroadcast />
      <SessionTimeoutWrapper />
    </>
  );
});

export default App;
